var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSqm2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20833 7.29175V17.7084",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7917 17.7084V7.29175",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8334 21.8749H18.75C18.175 21.8749 17.7084 21.4083 17.7084 20.8333V18.7499C17.7084 18.1749 18.175 17.7083 18.75 17.7083H20.8334C21.4084 17.7083 21.875 18.1749 21.875 18.7499V20.8333C21.875 21.4083 21.4084 21.8749 20.8334 21.8749Z",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 21.8749H4.16667C3.59167 21.8749 3.125 21.4083 3.125 20.8333V18.7499C3.125 18.1749 3.59167 17.7083 4.16667 17.7083H6.25C6.825 17.7083 7.29167 18.1749 7.29167 18.7499V20.8333C7.29167 21.4083 6.825 21.8749 6.25 21.8749Z",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8334 7.29167H18.75C18.175 7.29167 17.7084 6.825 17.7084 6.25V4.16667C17.7084 3.59167 18.175 3.125 18.75 3.125H20.8334C21.4084 3.125 21.875 3.59167 21.875 4.16667V6.25C21.875 6.825 21.4084 7.29167 20.8334 7.29167Z",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 7.29167H4.16667C3.59167 7.29167 3.125 6.825 3.125 6.25V4.16667C3.125 3.59167 3.59167 3.125 4.16667 3.125H6.25C6.825 3.125 7.29167 3.59167 7.29167 4.16667V6.25C7.29167 6.825 6.825 7.29167 6.25 7.29167Z",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29163 19.7916H17.7083",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7083 5.20833H7.29163",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 15.625L15.625 9.375",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9792 15.6249H9.375V13.0208",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0209 9.375H15.625V11.9792",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqm2);
export default __webpack_public_path__ + "static/media/sqm2.8f0c2572730af56fc4c2aa0d8166743e.svg";
export { ForwardRef as ReactComponent };